import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SubmitCreditMemoParams } from "../types/SubmitCreditMemoParams";
import { SubmitCreditMemoResult } from "../types/SubmitCreditMemoResult";

export const useSubmitCreditMemo = (params: SubmitCreditMemoParams) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("purchase-order/submit-credit-memo",
				{ creditMemo: params.creditMemo, products: params.products }) as SubmitCreditMemoResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				params.onSuccess(result.creditMemoID);
			else
				params.onError('Error when submitting invoice: ' + result.errorMessage!);
		},
		onError(error) {
			params.onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
